import { render, staticRenderFns } from "./articleeditform.vue?vue&type=template&id=2de5e71c&"
import script from "../../ts/articleattributes/articleeditform.ts?vue&type=script&lang=js&"
export * from "../../ts/articleattributes/articleeditform.ts?vue&type=script&lang=js&"
import style0 from "../../assets/css/articleattributes/articleeditform.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports